// extracted by mini-css-extract-plugin
export default {"card":"card___cQdK5","title":"title___HY0p1","active":"active___gGIAM","footer":"footer___Wpe3y"};